import React from 'react';

const ArrowRight = () => (
  <svg
    width="10"
    height="9"
    viewBox="0 0 10 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.99941 9L4.99941 1" stroke="#00D28F" strokeWidth="2" />
    <path
      d="M8.89961 5L4.99961 1L1.09961 5"
      stroke="#00D28F"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowRight;
